var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderstandMyBillPaperlessBills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30 0a30 30 0 1 0 30 30A30.034 30.034 0 0 0 30 0zm0 58a28 28 0 1 1 28-28 28.032 28.032 0 0 1-28 28z",
    fill: "#00206d",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.529 13.877 13.878 47.528a2.014 2.014 0 0 0-.587 1.546 1.969 1.969 0 0 0 .752 1.435 25.982 25.982 0 0 0 36.466-36.466 1.969 1.969 0 0 0-1.435-.752 2.036 2.036 0 0 0-1.545.586zM42 22.212V46a1 1 0 0 1-1 1H19a.987.987 0 0 1-.961-.807zm11.918 9.8a24.143 24.143 0 0 1-21.911 21.906 23.9 23.9 0 0 1-16.716-4.975l1.242-1.243A3 3 0 0 0 19 49h22a3 3 0 0 0 3-3V20.21l4.933-4.937a23.966 23.966 0 0 1 4.985 16.737zM46.709 10.926a1.969 1.969 0 0 0-.752-1.435A25.982 25.982 0 0 0 9.491 45.957a1.969 1.969 0 0 0 1.435.752h.122a2.013 2.013 0 0 0 1.423-.59l33.651-33.647a2.014 2.014 0 0 0 .587-1.546zM18 20h4.833A2.169 2.169 0 0 0 25 17.833V13h16a.987.987 0 0 1 .961.807L18 37.788zm1.414-2L23 14.414v3.419a.167.167 0 0 1-.167.167zm25.3-6.944L43.467 12.3A3 3 0 0 0 41 11H24a1 1 0 0 0-.707.293l-7 7A1 1 0 0 0 16 19v20.79l-4.933 4.937a23.988 23.988 0 0 1 33.646-33.68z",
    fill: "#00206d",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderstandMyBillPaperlessBills);
export default __webpack_public_path__ + "static/media/understandMyBill-PaperlessBills.fc7efa12a9a518ed976c89c39a3dd3a1.svg";
export { ForwardRef as ReactComponent };